import { desEncryptMessage, encryptSecretKey } from '@airtel/air-utils';
import { API_CONFIGS, COCP_TO_RETAIL_LAYOUT, LOGIN_CONSTANTS } from '../constants/AppConstants';
import { getFromSessionStorage } from '../utils/CommonUtils';
import { getInteractionId, generateUniqueId } from './commonUtils';

export const createUUID = () => {
   let dt = new Date().getTime();
   const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
   });

   return uuid;
};

export const encryptMessage = (payload: any, publickey: string) => {
   //generate random number
   const secretKey = createUUID();
   const stringifyPayload = JSON.stringify(payload);
   const currentTime = Date.now().toString();

   //DES encryption of payload
   const encryptedPayload = desEncryptMessage(stringifyPayload, secretKey);

   //DES encryption of timestamp
   const encryptedTimestamp = desEncryptMessage(currentTime, secretKey);

   //encrypt random key
   const encryptedKey = encryptSecretKey(secretKey, publickey);

   return `data=${encodeURIComponent(
      encryptedPayload
   )}&key=${encryptedKey}&timestamp=${encodeURIComponent(encryptedTimestamp)}`;
};

// bouncer send otp
export const callSendOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   // let isOtpModalOpened = data?.[0]?.type == 'resend' ? true : false;
   // const publicKey = localStorage.getItem('key');

   // if (publicKey) {
   // const payload: any = {
   //    msisdn: msisdn,
   //    otpDigitCount: 6,
   //    groupId: 'SKYC_REVERIFICATION',
   //    os: 'ANDROID_LITE',
   // };

   //encrypt the request using DES Algo
   // payloadReq = encryptMessage(payload, publicKey);
   // const payloadReq = JSON.stringify(payload);
   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v1';
   let apiUrlValidateOtp = 'guardian/api/skyc/validateOtp/v1';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'SKYC_REVERIFICATION',
               otpDigitCount: 6,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'close',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify mobile number',
                  subTitle: '6-digit OTP sent to',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 6,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           payload: {
                              eventData: {
                                 inputsDataProps: {
                                    mobileNumber: {
                                       showLoader: false,
                                    },
                                 },
                              },
                              eventName: 'step1Widget',
                           },
                           type: 'nativeEventEmitter',
                        },
                        {
                           type: 'closeModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'change',
                              eventValue: 'change',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'SKYC_LANDING_PAGE',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'verify',
                                 eventValue: 'verify',
                                 customLabel: 'mobile verification',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop8: 'reverification',
                                 prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                                 prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                                 prop5: '{{storeValues:outstationContext.isOutstation}}',
                              },
                           },
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'SKYC_LANDING_PAGE',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'resend',
                                 eventValue: 'resend',
                                 customLabel: 'mobile verification',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop8: 'reverification',
                                 prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                                 prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                                 prop5: '{{storeValues:outstationContext.isOutstation}}',
                              },
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventValue: 'filled',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        payload: {
                           eventData: {
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                              submitButtonProps: {
                                 leftCta: {
                                    disabled: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [
                     {
                        payload: {
                           eventData: {
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                              submitButtonProps: {
                                 leftCta: {
                                    disabled: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                  ],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        payload: {
                           eventData: {
                              state: 'none',
                              isExpanded: true,
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                     {
                        type: 'apiCall',
                        payload: {
                           requestType: 'POST',
                           apiUrl: 'guardian/api/skyc/reverification/status/v1',
                           authTokenGroup: 'SKYC_REVERIFICATION',
                           header: [],
                           body: {
                              channel: 'SHOP',
                              interactionId:
                                 '{{storeValues:skycInteractionId.interactionId}}',
                              operation: 'CUST_REVERIFICATION',
                              msisdn: '{{storeValues:appData.msisdn}}',
                              coordinates: '{{storeValues:userLocation}}',
                              otpGenerationDateTime:
                                 '{{storeValues:msisdnOtp.otpGenerationDateTime}}',
                              otpValidationDateTime:
                                 '{{storeValues:msisdnOtp.otpValidationDateTime}}',
                              otp: '{{storeValues:msisdnOtp.otp}}',
                           },
                        },
                     },
                  ],
               },
               apiUrls: {
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`,
                  verifyOtp: `${API_CONFIGS.baseUrl}${apiUrlValidateOtp}`,
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               customLabel: 'mobile verification',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         },
      ],
   });
};

//skyc-new bouncer send otp
export const callSendOtpSkycNew = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v2';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'SKYC_NEW',
               otpDigitCount: 6,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'close',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify alternate number via OTP',
                  subTitle: '6-digit OTP sent to verify and send updates on',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 6,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           type: 'closeModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'phone number',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'verify',
                                 customValue: '',
                                 customLabel: 'button',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 prop4: 'SKYC',
                                 prop9: '{{storeValues:appData.lob}}'
                              },
                           },
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'resend',
                                 customValue: '',
                                 customLabel: 'button',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 prop4: 'SKYC',
                                 prop9: '{{storeValues:appData.lob}}'
                              },
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventValue: 'filled',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        analyticsAction: 'click',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           eventValue: `6-digit otp sent to verify and send updates on ${msisdn}`,
                           eventLabel: 'verify alternate number via otp',
                           customValue: 'mobile verification',
                           customLabel: 'card',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: '{{storeValues:appData.subJourney}}',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}'
                        },
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        "payload": {
                           "eventData": {
                              "isEmailDisabled": false,
                              "isEmailautofocus": true,
                           },
                           "shouldResolveData": true,
                           "eventName": "UserDetailsWidget"
                        },
                        "type": "nativeEventEmitter"
                     }
                  ],
               },
               onVerifyOtpFailure: {
                  actions: [
                     {
                        analyticsAction: 'impression',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           customValue: 'mobile verification',
                           customLabel: 'OTP is incorrect',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: '{{storeValues:appData.subJourney}}',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}',
                           eVar10: 'error'
                        }
                     }
                  ],
               },
               apiUrls: {
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               customValue: 'mobile verification',
               customLabel: '',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               prop4: 'SKYC',
               prop9: '{{storeValues:appData.lob}}'
            },
         },
      ],
   });
};

// bouncer verify otp
export const validateOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const otp = storeValues?.msisdnOtp?.otp;

   //key
   const publicKey = localStorage.getItem('key');
   if (publicKey) {
      const payload: any = {
         msisdn: msisdn,
         otpDigitCount: 6,
         dynamicTokenRequired: true,
         otp: otp,
         groupId: 'SKYC_REVERIFICATION',
         os: 'ANDROID_LITE',
      };
      // encrypt the request using DES Algo
      // const payloadReq = encryptMessage(payload, publicKey);
      const payloadReq = JSON.stringify(payload);

      const apiUrlValidateLogin = 'guardian/api/skyc/validateOtp/v1';

      return onUserAction({
         actions: [
            {
               type: 'apiCall',
               payload: {
                  requestType: 'POST',
                  apiUrl: apiUrlValidateLogin,
                  body: {
                     key: payloadReq,
                  }
               },
            },
         ],
      });
   }
};

// aadhaar sent otp
export const callSendAadhaarOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const aadhaarNumber = storeValues?.appData?.aadhaarNumber;
   const msisdn = storeValues?.appData?.msisdn;
   const isOtpModalOpened = args?.[0]?.type === 'resend' ? true : false;
   const type = aadhaarNumber?.length === 12 ? 'A' : 'V';
   const apiUrlSentOtp = 'guardian/api/skyc/aadhaar/sendOtp/v1';
   const circleId = storeValues?.trackOrderContext
      ? storeValues?.trackOrderContext?.circleId
      : storeValues?.pincodeContext?.pincodeDetails?.circleId;
   const lob = storeValues?.appData?.lob || 'PREPAID';
   const selectedLayout = storeValues?.layoutContext?.layout;
   const isCocpLayout = selectedLayout === COCP_TO_RETAIL_LAYOUT;
   return onUserAction({
      actions: [
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlSentOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  msisdn,
                  interactionId: getInteractionId(getState,onUserAction),
                  circleId,
                  isResend: isOtpModalOpened,
                  
                  kycDetails: {
                     requestId: generateUniqueId(),
                     requestedFor: 'CUST',
                  },
                  contentPlaceholders: {},
                  documentProofs: [
                     {
                        id: aadhaarNumber,
                        type,
                     },
                  ],
                  lob,
                  ...(isCocpLayout && {
                     layout: 'TOC_COCP_TO_RETAIL',
                  }),
               },
               queryParams: {
                  "utm_layout": "{{additionalData:queryParams.utm_layout}}",
                  isOtpModalOpened,
                  
               },
            },
         },
         {
            payload: {
               data: {
                  isResendAadharOtp: isOtpModalOpened,
               },
               context: 'resendOtpContext',
            },
            type: 'storeValuesInRedux',
         }
      ],
   });
};

// aadhaar verify otp
export const callVerifyAadhaarOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const aadhaarNumber = storeValues?.appData?.aadhaarNumber;
   const msisdn = storeValues?.appData?.msisdn;
   const otpReferenceId = storeValues?.aadhaarOtpContext?.otpReferenceId;
   const mobileNumber = storeValues?.aadhaarOtpContext?.mobileNumber;
   const email = storeValues?.aadhaarOtpContext?.email;
   const otp = storeValues?.msisdnOtp?.aadhaarNumber;
   const incomeTNCText = args?.[0]?.incomeTNCText;
   const circleId = storeValues?.trackOrderContext?.circleId;
   const isResendAadharOtp = storeValues?.resendOtpContext?.isResendAadharOtp
   const { journey, layout } = storeValues?.journeyContext || {};
   const type = aadhaarNumber?.length === 12 ? 'A' : 'V';

   let apiUrlValidateOtp = 'guardian/api/skyc/aadhaar/validateOtp/v1';

   return onUserAction({
      actions: [
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlValidateOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  msisdn,
                  incomeTNCText,
                  otpReferenceId,
                  circleId,
                  isResend: isResendAadharOtp,
                  aadhaarNumber,
                  interactionId: getInteractionId(getState,onUserAction),
                  contentPlaceholders: {},
                  otp,
                  journey,
                  kycDetails: {
                     requestId: generateUniqueId(),
                     requestedFor: 'cust',
                     mobileNumber,
                     email,
                     residentConsent: true,
                  },
                  documentProofs: [
                     {
                        id: aadhaarNumber,
                        type,
                     },
                  ],
                  layout
               }
            },
         },
      ],
   });
};


// submit & local referre sent otp
export const callSendRefereeAndSubmitOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const isReferee = args?.[0]?.isReferee;
   const localMsisdn = storeValues?.appData?.localMsisdn;
   const msisdn = storeValues?.appData?.msisdn;
   const customerName = storeValues?.kycDetails?.aadhaarName;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   const { journey, layout } = storeValues?.journeyContext || {};
   const { planName } = storeValues?.planInfo || {};
   const isOtpModalOpened = args?.[0]?.type === 'resend' ? true : false;
   const apiUrlSentOtp = 'guardian/api/skyc/referee-and-submit/sendOtp/v1';
   const selectedNumber = storeValues?.numberContext?.selectedNumber;
   const kycId = storeValues?.skycInteractionId?.interactionId;
   if ((localMsisdn || msisdn) && localMsisdn === msisdn) {
      let actions: any = [
         {
            payload: {
               eventData: {
                  removeHintTextOnChange: true,
                  inputsDataProps: {
                     mobileNumber: {
                        hintText:
                           'This number & re-verification number cannot be same.',
                        state: 'error',
                     },
                  },
               },
               eventName: 'LOCAL_REFERENCE_DETAILS',
            },
            type: 'nativeEventEmitter',
         },
      ]

      if (journey === 'SKYC_NEW') {
         actions?.push(
            {
               analyticsAction: 'impression',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'LOCAL_REFERENCE_DETAILS',
                  eventAction: 'impression',
                  eventLabel: 'share a local reference',
                  eventValue: localMsisdn,
                  customValue: 'This number and re-verification number cannot be same',
                  customLabel: 'card',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            }
         )
      }
      return onUserAction({
         actions
      });
   }

   let actions = [
      {
         payload: {
            data: {
               isRefereeOtp: isReferee,
            },
            context: 'isReferee',
         },
         type: 'storeValuesInRedux',
      },
      {
         type: 'apiCall',
         payload: {
            requestType: 'POST',
            apiUrl: apiUrlSentOtp,
            authTokenGroup: 'SKYC_REVERIFICATION',
            body: {
               msisdn: isReferee ? localMsisdn : msisdn,
               customerName,
               isReferee,
               circleId,
               isResend: isOtpModalOpened,
               interactionId: getInteractionId(getState,onUserAction),
               coordinates: {
                  latitude: storeValues?.userLocation?.latitude?.toString(),
                  longitude: storeValues?.userLocation?.longitude?.toString(),
               },
               layout,
               ...(journey === 'SKYC_NEW' && {
                  contentPlaceholders: {
                     msisdn : selectedNumber,
                     planName,
                     customerName
                  }
               })
            },
            queryParams: {
               isOtpModalOpened,
            },
         },
      },
      {
         payload: {
            data: {
               isResendRefereeOtp: isReferee && isOtpModalOpened,
               isResendSubmitOtp: !isReferee && isOtpModalOpened,
            },
            context: 'resendOtpContext',
         },
         type: 'storeValuesInRedux',
      },
      {
         payload: {
            data: {
               otpGenerationTime: convertTimestampToDate(Date.now(), journey),
            },
            context: 'refreeAndSubmitOtp',
         },
         type: 'storeValuesInRedux',
      },
   ]
   return onUserAction({
      actions
   });
};

// submit & local referre verify otp
export const callVerifyRefereeAndSubmitOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const localMsisdn = storeValues?.appData?.localMsisdn;
   const msisdn = storeValues?.appData?.msisdn;
   const otp = storeValues?.refreeAndSubmitOtp?.otp;
   const isReferee = storeValues?.isReferee?.isRefereeOtp;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   let apiUrlValidateOtp = 'guardian/api/skyc/referee-and-submit/validateOtp/v1';
   const isResendRefereeOtp = storeValues?.resendOtpContext?.isResendRefereeOtp
   const isResendSubmitOtp = storeValues?.resendOtpContext?.isResendSubmitOtp
   const { journey, layout } = storeValues?.journeyContext || {};
   const { planName } = storeValues?.planInfo || {};
   const selectedNumber = storeValues?.numberContext?.selectedNumber;
   const customerName = storeValues?.kycDetails?.aadhaarName;
   const actions: any[] = [];

   actions?.push(
      {
         payload: {
            data: {
               otpValidationDateTime: convertTimestampToDate(Date.now(), journey),
            },
            context: 'refreeAndSubmitOtp',
         },
         type: 'storeValuesInRedux',
      }
   )

   actions?.push(
      {
         type: 'apiCall',
         payload: {
            requestType: 'POST',
            apiUrl: apiUrlValidateOtp,
            authTokenGroup: 'SKYC_REVERIFICATION',
            body: {
               ...(journey === 'SKYC_NEW' && { journey }),
               msisdn: isReferee ? localMsisdn : msisdn,
               interactionId: getInteractionId(getState,onUserAction),
               otp,
               isReferee,
               circleId,
               isResend: isReferee ? isResendRefereeOtp : isResendSubmitOtp,
               coordinates: {
                  latitude: storeValues?.userLocation?.latitude?.toString(),
                  longitude: storeValues?.userLocation?.longitude?.toString(),
               },
               ...(journey === 'SKYC_NEW' && {
                  contentPlaceholders: {
                     selectedNumber,
                     planName,
                     customer_name: customerName
                  },
                  layout
               })
            }
         },
      }
   )

   if(!isReferee){
      actions?.push({
         payload: {
            args: [
               {
                  dataLayer: {
                     stepName: 'confirm details',
                     clicktext: '',
                     event: 'otp_submit',
                  },
               },
            ],
            utilName: 'handleGtmDataLayerEvent',
         },
         type: 'callUtilFunction',
      });
   }

   return onUserAction({
      actions
   });
};

// function to convert timestamp to date
export const convertTimestampToDate = (timestamp: number, journey: string = "") => {
   const date = new Date(timestamp);

   const pad = (num: number, size: number = 2): string => {
      let s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
   };

   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1); // Months are zero-based
   const day = pad(date.getDate());
   const hours = pad(date.getHours());
   const minutes = pad(date.getMinutes());
   const seconds = pad(date.getSeconds());
   const milliseconds = pad(date.getMilliseconds(), 3);

   return `${year}-${month}-${day}${journey === "SKYC_NEW" ? "T" : " "}${hours}:${minutes}:${seconds}${journey === "IMAGE_MODAL" ? "" : "." + milliseconds}`;
};

export const storeBouncerSendOTP = ({ additionalData, onUserAction, getState }: any) => {
   const { timestamp } = additionalData?.dataFromWidget || {};
   const { storeValues = {} } = getState();
   const { journeyContext = {} } = storeValues;
   const { journey } = journeyContext;

   return onUserAction({
      actions: [
         {
            type: 'setDataInSessionStorage',
            payload: {
               key: 'msisdnOtp',
               value: {
                  otpGenerationDateTime: convertTimestampToDate(timestamp, journey),
               },
               clearOnLogout: false,
            },
         },
      ],
   });
};

export const storeBouncerValidateOTP = ({ additionalData, onUserAction, getState }: any) => {
   const { otp, timestamp } = additionalData?.dataFromWidget || {};
   const msisdnOtp = getFromSessionStorage("msisdnOtp")
   const { storeValues = {} } = getState();
   const { journeyContext = {} } = storeValues;
   const { journey } = journeyContext;

   return onUserAction({
      actions: [
         {
            type: 'setDataInSessionStorage',
            payload: {
               key: 'msisdnOtp',
               value: {
                  otp,
                  otpValidationDateTime: convertTimestampToDate(timestamp, journey),
                  ...msisdnOtp
               },
               clearOnLogout: false,
            },
         },
      ],
   });
};

//skyc-new bouncer send otp for prepaid
export const callSendOtpPrepaidSkyc = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const layout = storeValues?.journeyContext?.layout
   const isCocpLayout = layout === COCP_TO_RETAIL_LAYOUT

   const trackOrderPayload = {
      "payload": {
         "authTokenGroup": "SKYC_REVERIFICATION",
         "headers": {},
         "requestType": "POST",
         "apiUrl": "guardian/api/skyc/prepaid/track-order/v1",
         "queryParams": {
            "acquisitionType": "SKYC",
            "flow": "{{additionalData:queryParams.type}}"
         },
         "body": {
            "pageName": "newAcq",
            "identifier": msisdn,
            "acqPageVariant" : "{{storeValues:variants.AcqPage}}"
         },
         "loaderProps": {
            "show": true,
            "dismissAfterResponse": true
         }
      },
      "type": "apiCall"
   }

   const fetchUserDetailsPayload = {
      "payload": {
         "authTokenGroup": "SKYC_REVERIFICATION",
         "headers": {},
         "requestType": "POST",
         "apiUrl": "guardian/api/skyc/postpaid/fetch-user-details/v1",
         "queryParams": {
         },
         "body": {
            "msisdn":msisdn,
            "orderSubType": "TOC",
         },
         "loaderProps": {
            "show": true,
            "dismissAfterResponse": true
         }
      },
      "type": "apiCall"
   }

   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v2';

   const actions: any[] = [];

   actions?.push({
      type: 'otpConsent',
      payload: {
         msisdn,
         groupId: 'SKYC_NEW',
         otpDigitCount: 6,
         sessionStorageKey: 'SKYC_REVERIFICATION',
         modalProps: {
            width: 392,
            showCross: true,
            onClosePress: {
               actions: [
                  {
                     analyticsAction: 'click',
                     analyticsData: {
                        eventCategory: 'new_acq_postpaid_skyc_landing_page',
                        section: 'OtpModalSection',
                        subSection: 'AirOtpWidget',
                        eventAction: 'pageclose',
                        eVar0: isCocpLayout ? 'cocp_verify number via otp modal close' : 'skyc_alternate number_click on close cta',
                        isInteractive: 0,
                        eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
                        eVar21: '{{storeValues:appData.msisdn}}',
                        eVar20: '{{storeValues:appData.loggedInNumber}}',
                        city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                        eVar36 : '{{storeValues:numberContext.selectedNumber}}',
                        eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                        cartId: '{{storeValues:orderData.cartItemId}}',
                        eventLabel: 'verify',
                        prop5: '{{storeValues:planInfo.planId}}',
                        customLabel: 'button',
                        prop45:  isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
                        ticketId: '{{storeValues:orderData.cartId}}',
                        prop26: '',
                     },
                  },
               ],
            },
         },
         otpWidgetProps: {
            rtnOnChangeCta: true,
            title: isCocpLayout ? 'Verify number via OTP' : 'Verify alternate number via OTP',
            subTitle: 'Enter the 6-digit code sent to',
            infoTextTop: 'Enter OTP',
            resendTimerCount: 30,
            numberOfInputs: 6,
            startCounter: true,
            loadingTitle: 'verifying your number',
            state: 'none',
            isValidating: false,
            onChangeCtaPress: {
               id: 'onMsisdnChange',
               actions: [
                  {
                     type: 'closeModal',
                  },
                  {
                     analyticsAction: 'click',
                     analyticsData: {
                        eventCategory: 'new_acq_postpaid_skyc_landing_page',
                        section: 'OtpModalSection',
                        subSection: 'AirOtpWidget',
                        eventAction: 'click',
                        eventLabel: 'phone number',
                        customValue: '',
                        customLabel: 'button',
                        eVar21: '{{storeValues:appData.loggedInNumber}}',
                        extraData11: '{{storeValues:layoutContext.layout}}',
                        prop45: '{{storeValues:appData.subJourney}}',
                        eVar36: '{{storeValues:appData.msisdn}}',
                        prop4: 'SKYC',
                        prop9: '{{storeValues:appData.lob}}'
                     },
                  },
               ],
            },
            id: 'artistOtpModal',
            primaryCtaProps: {
               buttonType: 'primary',
               style: {
                  marginTop: 0,
                  backgroundColor: "#000000",
                  borderColor: "#000000"
               },
               title: 'Verify',
               size: 'md',
               onPress: {
                  actions: [
                     {
                        analyticsAction: 'click',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'click',
                           eVar0: isCocpLayout ? 'cocp_verify number via otp modal verify click' : 'skyc_alternate number_click on verify cta',
                           isInteractive: 1,
                           eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
                           eVar21: '{{storeValues:appData.msisdn}}',
                           eVar20: '{{storeValues:appData.loggedInNumber}}',
                           city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                           eVar36 : '{{storeValues:numberContext.selectedNumber}}',
                           eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                           cartId: '{{storeValues:orderData.cartItemId}}',
                           eventLabel: 'verify',
                           prop5: '{{storeValues:planInfo.planId}}',
                           customLabel: 'button',
                           prop45:  isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
                           ticketId: '{{storeValues:orderData.cartId}}',
                           prop26: '',
                        },
                     },
                     {
                        payload: {
                           args: [
                              {
                                 dataLayer: {
                                    stepName: '1|Personal Details',
                                    event: 'lead_otp_submit',
                                    clicktext: 'verify'
                                 },
                              },
                           ],
                           utilName: 'handleGtmDataLayerEvent',
                        },
                        type: 'callUtilFunction',
                     }
                  ],
               },
            },
            secondaryCtaProps: {
               buttonType: 'tertiary',
               counterSuffix: 's',
               style: {
                  alignSelf: 'center',
               },
               title: 'resend',
               version: 'fixed-padding',
               onPress: {
                  actions: [
                     {
                        analyticsAction: 'click',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'click',
                           eVar0: isCocpLayout ? 'cocp_verify number via otp modal resend click' : 'skyc_alternate number_click on resend cta',
                           isInteractive: 1,
                           eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
                           eVar21: '{{storeValues:appData.msisdn}}',
                           eVar20: '{{storeValues:appData.loggedInNumber}}',
                           city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                           eVar36 : '{{storeValues:numberContext.selectedNumber}}',
                           eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                           cartId: '{{storeValues:orderData.cartItemId}}',
                           eventLabel: 'resend',
                           prop5: '{{storeValues:planInfo.planId}}',
                           customLabel: 'button',
                           prop45:  isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
                           ticketId: '{{storeValues:orderData.cartId}}',
                           prop26: '',
                        },
                     },
                     {
                        payload: {
                           args: [
                              {
                                 dataLayer: {
                                    stepName: '1|Personal Details',
                                    event: 'otp_resend',
                                    clicktext: 'resend'
                                 },
                              },
                           ],
                           utilName: 'handleGtmDataLayerEvent',
                        },
                        type: 'callUtilFunction',
                     },
                  ],
               },
            },
            onInputFilled: {
               actions: [
                  {
                     analyticsAction: 'click',
                     analyticsData: {
                        eventCategory: 'new_acq_postpaid_skyc_landing_page',
                        section: 'OtpModalSection',
                        subSection: 'AirOtpWidget',
                        eventAction: 'click',
                        eVar0: isCocpLayout ? 'cocp_verify number via otp modal enter otp click' : 'skyc_alternate number_otp fill',
                        isInteractive: 1,
                        eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
                        customValue: 'success',
                        eVar21: '{{storeValues:appData.msisdn}}',
                        eVar20: '{{storeValues:appData.loggedInNumber}}',
                        city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                        eVar36 : '{{storeValues:numberContext.selectedNumber}}',
                        eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                        cartId: '{{storeValues:orderData.cartItemId}}',
                        eventLabel: 'enter otp',
                        prop5: '{{storeValues:planInfo.planId}}',
                        customLabel: 'button',
                        prop45:  isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
                        ticketId: '{{storeValues:orderData.cartId}}',
                        prop26: '',
                     },
                  }
               ],
            },
         },
         toastProps: {},
         onSendOtpSuccess: {
            actions: [
               {
                  payload: { args: [], utilName: 'storeBouncerSendOTP' },
                  type: 'callUtilFunction',
               },
               {
                  analyticsAction: 'click',
                  analyticsData: {
                     eventCategory: 'new_acq_postpaid_skyc_landing_page',
                     section: 'OtpModalSection',
                     subSection: 'AirOtpWidget',
                     eventAction: 'impression',
                     eventValue: `6-digit otp sent to verify and send updates on ${msisdn}`,
                     eventLabel: 'verify alternate number via otp',
                     customValue: 'mobile verification',
                     customLabel: 'card',
                     eVar21: '{{storeValues:appData.loggedInNumber}}',
                     extraData11: '{{storeValues:layoutContext.layout}}',
                     prop45: '{{storeValues:appData.subJourney}}',
                     eVar36: '{{storeValues:appData.msisdn}}',
                     prop4: 'SKYC',
                     prop9: '{{storeValues:appData.lob}}'
                  },
               },
            ],
         },
         onSendOtpFailure: {
            actions: [],
         },
         onVerifyOtpSuccess: {
            actions: [
               {
                  payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                  type: 'callUtilFunction',
               },
               isCocpLayout ? fetchUserDetailsPayload : trackOrderPayload
            ],
         },
         onVerifyOtpFailure: {
            actions: [
               {
                  analyticsAction: 'impression',
                  analyticsData: {
                     eventCategory: 'new_acq_postpaid_skyc_landing_page',
                     section: 'OtpModalSection',
                     subSection: 'AirOtpWidget',
                     eventAction: 'impression',
                     customValue: 'mobile verification',
                     customLabel: 'OTP is incorrect',
                     eVar21: '{{storeValues:appData.loggedInNumber}}',
                     extraData11: '{{storeValues:layoutContext.layout}}',
                     prop45: '{{storeValues:appData.subJourney}}',
                     eVar36: '{{storeValues:appData.msisdn}}',
                     prop4: 'SKYC',
                     prop9: '{{storeValues:appData.lob}}',
                     eVar10: 'error'
                  }
               }
            ],
         },
         apiUrls: {
            sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`
         },
      },
   });

   if(isCocpLayout){
      actions?.push( {
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: 'new_acq_postpaid_skyc_landing_page',
            section: 'OtpModalSection',
            subSection: 'AirOtpWidget',
            eventAction: 'pageopen',
            eVar0: 'cocp_verify number via otp modal open',
            isInteractive: 0,
            eventValue: 'verify number via otp',
            eVar21: '{{storeValues:appData.msisdn}}',
            eVar20: '{{storeValues:appData.loggedInNumber}}',
            city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
            eVar36 : '{{storeValues:numberContext.selectedNumber}}',
            eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
            eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
            cartId: '{{storeValues:orderData.cartItemId}}',
            eventLabel: '',
            prop5: '{{storeValues:planInfo.planId}}',
            customLabel: 'card',
            ticketId: '{{storeValues:orderData.cartId}}',
            prop26: '',
            prop45: "cocp",
         },
      });
   }else{
      actions?.push( {
         payload: {
            args: [
               {
                  dataLayer: {
                     stepName: '1|Personal Details',
                     event: 'otp_verification_viewed'
                  },
               },
            ],
            utilName: 'handleGtmDataLayerEvent',
         },
         type: 'callUtilFunction',
      });
   }

   actions?.push( {
      analyticsAction: 'click',
      analyticsData: {
         eventCategory: 'new_acq_postpaid_skyc_landing_page',
         section: 'OtpModalSection',
         subSection: 'AirOtpWidget',
         eventAction: 'pageloaded',
         eVar0: isCocpLayout ? 'cocp_verify number via otp modal load' : 'skyc_alternate number_otp modal load',
         isInteractive: 0,
         eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
         eVar21: '{{storeValues:appData.msisdn}}',
         eVar20: '{{storeValues:appData.loggedInNumber}}',
         city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
         eVar36 : '{{storeValues:numberContext.selectedNumber}}',
         eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
         eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
         cartId: '{{storeValues:orderData.cartItemId}}',
         eventLabel: '',
         prop5: '{{storeValues:planInfo.planId}}',
         customLabel: 'card',
         prop45: isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
         ticketId: '{{storeValues:orderData.cartId}}',
         prop26: '',
      },
   });

   actions?.push( {
      analyticsAction: 'impression',
      analyticsData: {
         eventCategory: 'new_acq_postpaid_skyc_landing_page',
         section: 'OtpModalSection',
         subSection: 'AirOtpWidget',
         eventAction: 'impression',
         eVar0: isCocpLayout ? 'cocp_verify number via otp modal impression' : 'skyc_alternate number_otp impression',
         isInteractive: 0,
         eventValue: isCocpLayout ? 'verify number via otp' : 'alternate number otp',
         eVar21: '{{storeValues:appData.msisdn}}',
         eVar20: '{{storeValues:appData.loggedInNumber}}',
         city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
         eVar36 : '{{storeValues:numberContext.selectedNumber}}',
         eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
         cartId: '{{storeValues:orderData.cartItemId}}',
         eventLabel: 'verify number via otp',
         prop5: '{{storeValues:planInfo.planId}}',
         customLabel: 'card',
         prop45: isCocpLayout ? 'cocp' : '{{storeValues:appData.orderType}}',
         ticketId: '{{storeValues:orderData.cartId}}',
         prop26: '',
      },
   });

   return onUserAction({
      actions
   });
};

// cocp-to-retail bouncer send otp
export const callSendOtpCocpToRetail = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;

   const fetchUserDetailsPayload = {
      "payload": {
         "authTokenGroup": "SKYC_REVERIFICATION",
         "headers": {},
         "requestType": "POST",
         "apiUrl": "guardian/api/skyc/postpaid/fetch-user-details/v1",
         "queryParams": {
         },
         "body": {
            "msisdn": msisdn,
            "orderSubType": "TOC",
         },
         "loaderProps": {
            "show": true,
            "dismissAfterResponse": true
         }
      },
      "type": "apiCall"
   }

   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v2';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'COCP_TO_RETAIL',
               otpDigitCount: 6,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  width: 392,
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'pageclose',
                              eVar0: 'cocp_verify number via otp modal close',
                              isInteractive: 0,
                              eventValue: 'verify number via otp',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              eVar20: '{{storeValues:appData.loggedInNumber}}',
                              city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                              eVar36: '{{storeValues:numberContext.selectedNumber}}',
                              eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                              cartId: '{{storeValues:orderData.cartItemId}}',
                              eventLabel: 'verify',
                              prop5: '{{storeValues:planInfo.planId}}',
                              customLabel: 'button',
                              prop45: 'cocp',
                              ticketId: '{{storeValues:orderData.cartId}}',
                              prop26: '',
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify number via OTP',
                  subTitle: 'Enter the 6-digit code sent to',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 6,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           type: 'closeModal',
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                        backgroundColor: "#000000",
                        borderColor: "#000000"
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eVar0: 'cocp_verify number via otp modal verify click',
                                 isInteractive: 1,
                                 eventValue: 'verify number via otp',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 eVar20: '{{storeValues:appData.loggedInNumber}}',
                                 city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                 eVar36: '{{storeValues:numberContext.selectedNumber}}',
                                 eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                                 cartId: '{{storeValues:orderData.cartItemId}}',
                                 eventLabel: 'verify',
                                 prop5: '{{storeValues:planInfo.planId}}',
                                 customLabel: 'button',
                                 prop45: 'cocp',
                                 ticketId: '{{storeValues:orderData.cartId}}',
                                 prop26: '',
                              },
                           },
                           {
                              payload: {
                                 args: [
                                    {
                                       dataLayer: {
                                          stepName: '1|Personal Details',
                                          event: 'lead_otp_submit',
                                          clicktext: 'verify'
                                       },
                                    },
                                 ],
                                 utilName: 'handleGtmDataLayerEvent',
                              },
                              type: 'callUtilFunction',
                           }
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eVar0: 'cocp_verify number via otp modal resend click',
                                 isInteractive: 1,
                                 eventValue: 'verify number via otp',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 eVar20: '{{storeValues:appData.loggedInNumber}}',
                                 city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                 eVar36: '{{storeValues:numberContext.selectedNumber}}',
                                 eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                                 cartId: '{{storeValues:orderData.cartItemId}}',
                                 eventLabel: 'resend',
                                 prop5: '{{storeValues:planInfo.planId}}',
                                 customLabel: 'button',
                                 prop45: 'cocp',
                                 ticketId: '{{storeValues:orderData.cartId}}',
                                 prop26: '',
                              },
                           },
                           {
                              payload: {
                                 args: [
                                    {
                                       dataLayer: {
                                          stepName: '1|Personal Details',
                                          event: 'otp_resend',
                                          clicktext: 'resend'
                                       },
                                    },
                                 ],
                                 utilName: 'handleGtmDataLayerEvent',
                              },
                              type: 'callUtilFunction',
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eVar0: 'cocp_verify number via otp modal enter otp click',
                              isInteractive: 1,
                              eventValue: 'verify number via otp',
                              customValue: 'success',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              eVar20: '{{storeValues:appData.loggedInNumber}}',
                              city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                              eVar36: '{{storeValues:numberContext.selectedNumber}}',
                              eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                              cartId: '{{storeValues:orderData.cartItemId}}',
                              eventLabel: 'enter otp',
                              prop5: '{{storeValues:planInfo.planId}}',
                              customLabel: 'button',
                              prop45: 'cocp',
                              ticketId: '{{storeValues:orderData.cartId}}',
                              prop26: '',
                           },
                        }
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     fetchUserDetailsPayload
                  ],
               },
               onVerifyOtpFailure: {
                  actions: [
                     {
                        analyticsAction: 'impression',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           customValue: 'mobile verification',
                           customLabel: 'OTP is incorrect',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: 'cocp',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}',
                           eVar10: 'error'
                        }
                     }
                  ],
               },
               apiUrls: {
                  // utm_layout lets shared sendOtp/v2 BFF gate COCP_TO_RETAIL groupId without affecting other journeys
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}?utm_layout=${COCP_TO_RETAIL_LAYOUT}`
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageopen',
               eVar0: 'cocp_verify number via otp modal open',
               isInteractive: 0,
               eventValue: 'verify number via otp',
               eVar21: '{{storeValues:appData.msisdn}}',
               eVar20: '{{storeValues:appData.loggedInNumber}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar36: '{{storeValues:numberContext.selectedNumber}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               cartId: '{{storeValues:orderData.cartItemId}}',
               eventLabel: '',
               prop5: '{{storeValues:planInfo.planId}}',
               customLabel: 'card',
               ticketId: '{{storeValues:orderData.cartId}}',
               prop26: '',
               prop45: "cocp",
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               eVar0: 'cocp_verify number via otp modal load',
               isInteractive: 0,
               eventValue: 'verify number via otp',
               eVar21: '{{storeValues:appData.msisdn}}',
               eVar20: '{{storeValues:appData.loggedInNumber}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar36: '{{storeValues:numberContext.selectedNumber}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               cartId: '{{storeValues:orderData.cartItemId}}',
               eventLabel: '',
               prop5: '{{storeValues:planInfo.planId}}',
               customLabel: 'card',
               prop45: 'cocp',
               ticketId: '{{storeValues:orderData.cartId}}',
               prop26: '',
            },
         },
         {
            analyticsAction: 'impression',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'impression',
               eVar0: 'cocp_verify number via otp modal impression',
               isInteractive: 0,
               eventValue: 'verify number via otp',
               eVar21: '{{storeValues:appData.msisdn}}',
               eVar20: '{{storeValues:appData.loggedInNumber}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar36: '{{storeValues:numberContext.selectedNumber}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
               cartId: '{{storeValues:orderData.cartItemId}}',
               eventLabel: 'verify number via otp',
               prop5: '{{storeValues:planInfo.planId}}',
               customLabel: 'card',
               prop45: 'cocp',
               ticketId: '{{storeValues:orderData.cartId}}',
               prop26: '',
            },
         },
      ],
   });
};

//skyc-new bouncer send otp for activation of sim card for prepaid
export const sendOtpSimActivation = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.simActivationContext?.msisdn;

   const trackOrderPayload = {
      "payload": {
         "authTokenGroup": "SKYC_REVERIFICATION",
         "headers": {},
         "requestType": "POST",
         "apiUrl": "guardian/api/skyc/prepaid/track-order/v1",
         "queryParams": {
            "acquisitionType": "SKYC",
            "flow": "{{additionalData:queryParams.type}}"
         },
         "body": {
            "pageName": "simActivation",
            "identifier": msisdn,
            "flow": "SKYC_NEW"
         },
         "loaderProps": {
            "show": true,
            "dismissAfterResponse": true
         }
      },
      "type": "apiCall"
   }

   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v2';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'SKYC_NEW',
               otpDigitCount: 4,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  width: 392,
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'close',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify mobile number',
                  subTitle: '4-digit OTP sent to verify and send updates on',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 4,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           type: 'closeModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'phone number',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                        backgroundColor: '#000000',
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                           analyticsAction: 'click',
                           analyticsData: {
                              eVar0: 'skyc_sim activation Click on verify CTA',
                              eventCategory: 'SIM_ACTIVATION_PAGE',
                              section: 'otpmodalsection',
                              subSection: 'airotpwidget',
                              eventAction: 'click',
                              eventLabel: 'verify',
                              eventValue: 'success',
                              customLabel: 'button',
                              isInteractive: 1,
                              ticketId: storeValues?.orderData?.cartId,
                              cartId: storeValues?.orderData?.cartItemId,
                              eVar20: storeValues?.appData?.loggedInNumber,
                              eVar21: storeValues?.appData?.msisdn,
                              prop5: "",
                              prop45: storeValues?.appData?.orderType,
                              prop26: "",
                              eVar36: storeValues?.trackOrderContext?.selectedMsisdn,
                              city: storeValues?.pincodeContext?.pincodeDetails?.city,
                              eVar25: storeValues?.pincodeContext?.pincodeDetails?.circleId,
                              eVar33: storeValues?.pincodeContext?.pincodeDetails?.pincode
                           },
                        }
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'resend',
                                 customValue: '',
                                 customLabel: 'button',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 prop4: 'SKYC',
                                 prop9: '{{storeValues:appData.lob}}'
                              },
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eVar0: 'skyc_sim activation OTP fill',
                              eventCategory: 'SIM_ACTIVATION_PAGE',
                              section: 'otpmodalsection',
                              subSection: 'airotpwidget',
                              eventAction: 'click',
                              eventLabel: 'enter otp',
                              eventValue: 'success',
                              customLabel: 'button',
                              isInteractive: 1,
                              ticketId: storeValues?.orderData?.cartId,
                              cartId: storeValues?.orderData?.cartItemId,
                              eVar20: storeValues?.appData?.loggedInNumber,
                              eVar21: storeValues?.appData?.msisdn,
                              prop5: "",
                              prop45: storeValues?.appData?.orderType,
                              prop26: "",
                              eVar36: storeValues?.trackOrderContext?.selectedMsisdn,
                              city: storeValues?.pincodeContext?.pincodeDetails?.city,
                              eVar25: storeValues?.pincodeContext?.pincodeDetails?.circleId,
                              eVar33: storeValues?.pincodeContext?.pincodeDetails?.pincode
                           },
                        }
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        analyticsAction: 'click',
                        analyticsData: {
                           eVar0: 'skyc_sim activation otp Impression',
                           eventCategory: 'SIM_ACTIVATION_PAGE',
                           section: 'otpmodalsection',
                           subSection: 'airotpwidget',
                           eventAction: 'impression',
                           eventLabel: 'verify number via otp',
                           customLabel: 'card',
                           isInteractive: 0,
                           ticketId: storeValues?.orderData?.cartId,
                           cartId: storeValues?.orderData?.cartItemId,
                           eVar20: storeValues?.appData?.loggedInNumber,
                           eVar21: storeValues?.appData?.msisdn,
                           prop5: "",
                           prop45: storeValues?.appData?.orderType,
                           prop26: "",
                           eVar36: storeValues?.trackOrderContext?.selectedMsisdn,
                           city: storeValues?.pincodeContext?.pincodeDetails?.city,
                           eVar25: storeValues?.pincodeContext?.pincodeDetails?.circleId,
                           eVar33: storeValues?.pincodeContext?.pincodeDetails?.pincode
                        },
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     trackOrderPayload,
                  ],
               },
               onVerifyOtpFailure: {
                  actions: [
                     {
                        analyticsAction: 'impression',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           customValue: 'mobile verification',
                           customLabel: 'OTP is incorrect',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: '{{storeValues:appData.subJourney}}',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}',
                           eVar10: 'error'
                        }
                     }
                  ],
               },
               apiUrls: {
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               customValue: 'mobile verification',
               customLabel: '',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               prop4: 'SKYC',
               prop9: '{{storeValues:appData.lob}}'
            },
         },
      ],
   });
};


//skyc-new bouncer send otp for prepaid
export const callBouncerOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const { milestone } = args;
   const msisdn = storeValues?.appData?.msisdn;
   const actions: any[] = [];

   let apiPayload={};
   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v1';
   let apiUrlValidateOtp = 'guardian/api/skyc/validateOtp/v1';

   if(milestone=="init"){

      sessionStorage.removeItem(LOGIN_CONSTANTS.groupId)


    apiPayload = {
      "payload": {
         "authTokenGroup": LOGIN_CONSTANTS.groupId,
         "headers": {},
         "requestType": "POST",
         "apiUrl": "guardian/api/buy/skyc/track-order/v1",
         "queryParams": {
            "acquisitionType": "SKYC"
         },
         "body": {
            "pageName": "newAcq",
            "lob":"{{storeValues:appData.lob}}"
         },
         "loaderProps": {
            "show": true,
            "dismissAfterResponse": true
         }
      },
      "type": "apiCall"
   }
   }
   

   actions?.push({
      type: 'otpConsent',
      payload: {
         msisdn,
         groupId: LOGIN_CONSTANTS.groupId,
         otpDigitCount: 6,
         sessionStorageKey: LOGIN_CONSTANTS.groupId,
         modalProps: {
            width: 392,
            showCross: true,
            onClosePress: {
               actions: [
                  
               ],
            },
         },
         otpWidgetProps: {
            theme: "gen4",
            rtnOnChangeCta: true,
            title: 'Verify mobile number',
            subTitle: '6-digit OTP sent to',
            infoTextTop: 'Enter OTP',
            resendTimerCount: 30,
            numberOfInputs: 6,
            startCounter: true,
            loadingTitle: 'verifying your number',
            state: 'none',
            isValidating: false,
            style: {
               marginTop: -20
            },
            onChangeCtaPress: {
               id: 'onMsisdnChange',
               actions: [
                  {
                  type: 'closeModal',
                  }
               ],
            },
            id: 'artistOtpModal',
            primaryCtaProps: {
               buttonType: 'primary',
               style: {
            marginTop: 0,
            backgroundColor: "#000000",
            borderColor: "#000000",
            borderTopWidth: 1,
            borderTopColor: "#E6E9EF"
            },
               title: 'Confirm',
               size: 'lg',
               onPress: {
                  actions: [],
               },
            },
         secondaryCtaProps: {
            title: "Resend OTP",
            buttonType: 'tertiary',
            counterSuffix: 's',
            style: {
               marginTop: 16,
               marginBottom: 90,
               alignSelf: 'center',
            },
            version: 'fixed-padding',
            onPress: {
               actions: [],
            },
         },
         onInputFilled: {
            actions: [],
         },
         calloutWidgetProps: {
            description: "Your information stays safe with Airtel",
            iconName: "SecuredIcon",
            state: "success",
            isDark: false,
            showCrossDismissBtn: false,
            style: {
               marginTop: 16,
               marginBottom: 8,
               backgroundColor: "#E8F8EF",
               borderColor: "#E8F8EF"
            }
         }, },
         toastProps: {},
         onSendOtpSuccess: {
            actions: [
               {
                  payload: { args: [], utilName: 'storeBouncerSendOTP' },
                  type: 'callUtilFunction',
               }
            ],
         },
         onSendOtpFailure: {
            actions: [],
         },
         onVerifyOtpSuccess: {
            actions: [
               {
                  payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                  type: 'callUtilFunction',
               },
               apiPayload
            ],
         },
         onVerifyOtpFailure: {
            actions: [
              
            ],
         }
      },
   });
  
   return onUserAction({
      actions
   });
};